import React from "react";
import { api, state, ui } from "../../../../../../../../../interfaces/interfaces";
import { useAppSelector } from "@store/hooks";
import { AddressUtils } from "@utils/address";

const checkBlacklist = async (property: string, setBlacklist: { (value: React.SetStateAction<boolean>): void; (arg0: any): void; }) => {
    const address = `${property}`.substring(0, 10);
    const result = await AddressUtils.checkAddressBlacklist({ ui, address })
    setBlacklist(result)
}

const checkCaravanSiteBlacklist = async (property: string, setBlacklist: { (value: React.SetStateAction<boolean>): void; (arg0: any): void; }) => {
    const address = `${property}`.substring(0, 10);
    const result = await AddressUtils.checkAddressBlacklistForCaravanSites({ ui, address })
    setBlacklist(result)
}

//create hook useBlacklist
export const useBlacklist = () => {
    const [blacklist, setBlacklist] = React.useState<boolean>(false);
    const postcode = useAppSelector(({ ui }) => ui.PropertyAddressPostcode);
    const property = useAppSelector(({ ui }) => ui.PropertyAddressProperty);

    // useEffect to set blacklist
    React.useEffect(() => {
        if (postcode && property) {
            checkBlacklist(property, setBlacklist);
        }
        else {
            blacklist && setBlacklist(false);
        }
    }, [postcode, property, blacklist]);

    return blacklist
}

export const useCaravanSiteBlacklist = () => {
    const [blacklist, setBlacklist] = React.useState<boolean>(false);
    const propertyPostcode = useAppSelector(({ ui }) => ui.PropertyAddressPostcode);
    const property = useAppSelector(({ ui }) => ui.PropertyAddressProperty);

    // useEffect to set blacklist
    React.useEffect(() => {
        if (propertyPostcode && property) {
            checkCaravanSiteBlacklist(property, setBlacklist);
        }
        else {
            blacklist && setBlacklist(false);
        }
    }, [propertyPostcode, property, blacklist]);

    return blacklist
}


const checkLastJob = async (property: string) => {
    const postcode = state.JobPostcode;
    if (postcode && property) {
        const result = await api.fetchLastJob({ postcode, property, jobId: state.JobId, tradeCode: state.JobTradeCode })
        await api.fetchLast2({ postcode, property })
        if (result && result.length > 0 && result[0].jobId !== state.LastJob[0]?.jobId) {
            state.LastJob = result;
        }
        else if (result && result.length === 0 && state.LastJob[0]?.jobId) {
            state.LastJob = [];
        }
    }
}

// create hook useLastJob
export const useLastJob = () => {
    const activeSearch = useAppSelector(({ temp }) => temp.ProblemAddressActiveSearch);
    const property = useAppSelector(({ ui }) => ui.PropertyAddressProperty);
    const lastJob = useAppSelector(({ state }) => state.LastJob);
    const tradeCode = useAppSelector(({ ui }) => ui.ProblemComboTrade);

    // useEffect to set lastJob
    React.useEffect(() => {
        if (activeSearch && tradeCode?.tradeCode) {
            checkLastJob(property);
        }
    }, [activeSearch, property, tradeCode?.tradeCode]);

    return lastJob;
}